import Vue from 'vue'
import Vuex from 'vuex'
import i18n from '../translation'
import router from '../router'
import createPersistedState from 'vuex-persistedstate'
import _watcheebox from '../components/watcheebox/watcheebox.js'

/**
 * Modules Watcheezy
 */
import { _Toolbar } from './toolbar'
import { _Notifier } from './notifier'
import { _Dialog } from './dialog'
import { _User } from './user'
import { _Biblios } from './biblios'
import { _Reports } from './reports'
import { _Sites } from './sites'
import { _StoreWatcheeBox } from './storeWatcheeBox'
import { _Stats } from './stats'

Vue.use(Vuex)

/**
 * Instance de Vuex (store global) synchronisé avec une instance de vue-router afin de gérer le routing
 * et afin qu'il soit synchro avec le state général de l'application
 */
const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    _Toolbar,
    _Notifier,
    _Dialog,
    _User,
    _Biblios,
    _Reports,
    _Sites,
    _StoreWatcheeBox,
    _Stats
  },
  state: {
    // indique si l'utilisateur est loggué
    logged: false,
    // indique la raison du rechargement de la page
    reasonUnload: null,
    // indique la raison de la deconnexion du BO
    reasonDeco: null
  },
  getters: {
    logged: state => state.logged
  },
  mutations: {
    loginUser (state, {user, path}) {
      state.logged = true
      i18n.locale = user.lang
      state._User = user
      router.push({ path: path })
    },
    logout (state) {
      let goToAdmin = state._User.connectFromAdmin
      let id = state._User.entId
      router.push({ path: '/login' })
      state.logged = false
      state._User = {}
      if (goToAdmin) {
        window.location.href = `http://www.watcheezy.net/admin/licence/licence_n.php?id=${id}`
      } else {
        window.location.reload()
      }
    },
    SET_REASON_UNLOAD (state, reason) {
      state.reasonUnload = reason
    },
    SET_REASON_DECO (state, reason) {
      state.reasonDeco = reason
    }
  },
  actions: {
    loginUser ({commit, dispatch}, user) {
      commit('_Toolbar/INIT')
      commit('_Notifier/INIT')
      commit('_StoreWatcheeBox/INIT')
      // Lancement de plusieurs promesses simultanées
      Promise.all([
        dispatch('_Biblios/GET', user.id),
        dispatch('_Sites/GET'),
        dispatch('_Sites/GET_MAPPING')
      ]).then(() => {
        // après avoir récupéré les sites
        // changement de route en fonction du role de l'agent
        let path = ''
        if (user.rights === '0' || user.rights === '1') {
          path = '/trafic/visitors'
        } else {
          path = '/stats/audience'
        }
        commit('loginUser', {user: user, path: path})
        commit('_Stats/INIT')
      })
    },
    logout ({commit, state}, socket) {
      if (!state._StoreWatcheeBox.sessionDejaActive) {
        commit('_StoreWatcheeBox/SOCKET_DISCONNECT_CLIENT')
        if (socket) {
          _watcheebox.changeStatusAgent(
            {
              'statut': 'offline',
              'agentID': state._User.id,
              'sessionsPrivees': [],
              'roomName': state._User.entKey,
              'socket': socket
            }
          )
        }
      }
      commit('_StoreWatcheeBox/INIT')
      commit('_Biblios/INIT')
      commit('_Sites/INIT')
      commit('_Stats/INIT')
      commit('_Toolbar/INIT')
      commit('_Notifier/INIT')
      commit('logout')
    }
  },
  // Garder la persistance du store lors d'un refresh (dans le localStorage)
  plugins: [createPersistedState()]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js